/**
 * 判断值是否为数字
 * @return 是否为数字
 */
function isNumber(value) {
    return typeof value === 'number';
}

export { isNumber as default };
//# sourceMappingURL=is-number.js.map
